<template>
    <div class="tyn-root">
        <Header></Header>

        <div class="tyn-content tyn-content-page">
            <div class="tyn-main">
                <div class="tyn-section pt-0 pb-0">

                    <div class="artefatos-bar bg-white">
                        <div class="container-fluid px-3 position-relative">
                            <button class="scroll-btn left"
                                    v-if="podeScrollEsquerda"
                                    @click="scrollEsquerda">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z" />
                                </svg>
                            </button>

                            <div class="artefato-scroll-wrapper" ref="scrollContainer">
                                <div class="artefato-container">
                                    <CardArtefatoGeral v-for="modelo in lstModelos"
                                                       :key="modelo.idProcessoModeloArtefato || modelo.cdModelo"
                                                       :nmModelo="modelo.nmModelo"
                                                       :icone="modelo.nmIcone"
                                                       :ativo="modeloSelecionado && (modeloSelecionado.idProcessoModeloArtefato === modelo.idProcessoModeloArtefato || modeloSelecionado.cdModelo === modelo.cdModelo)"
                                                       @click.native="selecionarModelo(modelo)" />
                                </div>
                            </div>

                            <button class="scroll-btn right"
                                    v-if="podeScrollDireita"
                                    @click="scrollDireita">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z" />
                                </svg>
                            </button>
                        </div>
                    </div>

                    <div v-if="modeloSelecionado" class="table-container">
                        <div class="table-wrapper">
                            <div class="custom-table-header bg-white text-gray-900 dark:bg-gray-800 dark:text-gray-100">
                                <div class="d-flex flex-column gap-1">
                                    <h3>Processos gerais</h3>
                                    <small>{{ modeloSelecionado.nmModelo }}</small>
                                </div>
                                <button type="button"
                                        class="filter-toggle-btn"
                                        @click="toggleFiltros"
                                        :class="{ 'active': mostrarFiltros }"
                                        :title="temFiltrosAtivos ? 'Filtros ativos' : 'Filtrar resultados'">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
                                        <path d="M15,19.88C15.04,20.18 14.94,20.5 14.71,20.71C14.32,21.1 13.69,21.1 13.3,20.71L9.29,16.7C9.06,16.47 8.96,16.16 9,15.87V10.75L4.21,4.62C3.87,4.19 3.95,3.56 4.38,3.22C4.57,3.08 4.78,3 5,3V3H19V3C19.22,3 19.43,3.08 19.62,3.22C20.05,3.56 20.13,4.19 19.79,4.62L15,10.75V19.88M7.04,5L11,10.06V15.58L13,17.58V10.05L16.96,5H7.04Z" />
                                    </svg>
                                    <span v-if="temFiltrosAtivos" class="filter-badge"></span>
                                </button>
                            </div>

                            <!-- Painel de Filtros -->
                            <transition name="slide-filters">
                                <div v-if="mostrarFiltros" class="filters-panel">
                                    <div class="filters-grid">
                                        <!-- Data início -->
                                        <div class="filter-item">
                                            <label class="filter-label">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 24 24" class="filter-icon">
                                                    <path d="M9,10V12H7V10H9M13,10V12H11V10H13M17,10V12H15V10H17M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5A2,2 0 0,1 5,3H6V1H8V3H16V1H18V3H19M19,19V8H5V19H19M9,14V16H7V14H9M13,14V16H11V14H13M17,14V16H15V14H17Z" />
                                                </svg>

                                                Data início
                                            </label>
                                            <input type="date"
                                                   class="filter-input"
                                                   v-model="filtro.dtInicio" />
                                        </div>

                                        <!-- Data fim -->
                                        <div class="filter-item">
                                            <label class="filter-label">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 24 24" class="filter-icon">
                                                    <path d="M9,10V12H7V10H9M13,10V12H11V10H13M17,10V12H15V10H17M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5A2,2 0 0,1 5,3H6V1H8V3H16V1H18V3H19M19,19V8H5V19H19M9,14V16H7V14H9M13,14V16H11V14H13M17,14V16H15V14H17Z" />
                                                </svg>
                                                Data fim
                                            </label>
                                            <input type="date"
                                                   class="filter-input"
                                                   v-model="filtro.dtFim" />
                                        </div>

                                        <!-- Usuário responsável -->
                                        <div class="filter-item">
                                            <label class="filter-label">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" class="filter-icon">
                                                    <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0" />
                                                    <path fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1" />
                                                </svg>
                                                Responsável
                                            </label>
                                            <div class="select-wrapper">
                                                <select class="filter-input filter-select"
                                                        v-model="filtro.dsLoginResponsavel">
                                                    <option :value="null">Todos</option>
                                                    <option v-for="u in lstUsuarios"
                                                            :key="u.dsLogin"
                                                            :value="u.dsLogin">
                                                        {{ u.nmUsuario || u.dsLogin }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>

                                        <!-- Status de prazo -->
                                        <div class="filter-item">
                                            <label class="filter-label">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 24 24" class="filter-icon">
                                                    <path d="M15.5,12C18,12 20,14 20,16.5C20,17.38 19.75,18.21 19.31,18.9L22.39,22L21,23.39L17.88,20.32C17.19,20.75 16.37,21 15.5,21C13,21 11,19 11,16.5C11,14 13,12 15.5,12M15.5,14A2.5,2.5 0 0,0 13,16.5A2.5,2.5 0 0,0 15.5,19A2.5,2.5 0 0,0 18,16.5A2.5,2.5 0 0,0 15.5,14M5,3H19C20.11,3 21,3.89 21,5V13.03C20.5,12.23 19.81,11.54 19,11V5H5V19H9.5C9.81,19.75 10.26,20.42 10.81,21H5C3.89,21 3,20.11 3,19V5C3,3.89 3.89,3 5,3M7,7H17V9H7V7M7,11H12.03C11.23,11.5 10.54,12.19 10,13H7V11M7,15H9.17C9.06,15.5 9,16 9,16.5V17H7V15Z" />
                                                </svg>
                                                Status de prazo
                                            </label>
                                            <div class="select-wrapper">
                                                <select class="filter-input filter-select"
                                                        v-model.number="filtro.tpStatusPrazo">
                                                    <option v-for="opt in opcoesStatusPrazo"
                                                            :key="opt.text"
                                                            :value="opt.value">
                                                        {{ opt.text }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="filters-actions">
                                        <button type="button"
                                                class="filter-btn filter-btn-secondary"
                                                @click="limparFiltros">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                                            </svg>
                                            Limpar
                                        </button>
                                        <button type="button"
                                                class="filter-btn filter-btn-primary"
                                                @click="aplicarFiltros">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                                            </svg>
                                            Aplicar
                                        </button>
                                    </div>
                                </div>
                            </transition>

                            <table class="custom-table bg-white text-gray-900 dark:bg-gray-800 dark:text-gray-100">
                                <thead>
                                    <tr>
                                        <th class="text-center">
                                            <div class="th-wrapper">
                                                <span class="th-title">Número do Processo</span>
                                                <button @click="ordenarPor('cdProcesso')"
                                                        class="btn btn-sort"
                                                        :class="{
                        'text-primary': orderField === 'cdProcesso',
                        'text-gray-300': orderField !== 'cdProcesso'
                    }">
                                                    <template v-if="orderField === 'cdProcesso' && orderDirection === 'ASC'">
                                                        <!-- seta pra cima -->
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" viewBox="0 0 16 16">
                                                            <path fill-rule="evenodd"
                                                                  d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z" />
                                                        </svg>
                                                    </template>
                                                    <template v-else>
                                                        <!-- seta pra baixo -->
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" viewBox="0 0 16 16">
                                                            <path fill-rule="evenodd"
                                                                  d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                                                        </svg>
                                                    </template>
                                                </button>
                                            </div>
                                        </th>

                                        <!-- Nome do Processo (dsNomeProcesso - 3/4) -->
                                        <th>
                                            <div class="th-wrapper left">
                                                <span class="th-title">Nome do Processo</span>
                                                <button @click="ordenarPor('dsNomeProcesso')"
                                                        class="btn btn-sort-inline"
                                                        :class="{
                        'text-primary': orderField === 'dsNomeProcesso',
                        'text-gray-300': orderField !== 'dsNomeProcesso'
                    }">
                                                    <template v-if="orderField === 'dsNomeProcesso' && orderDirection === 'ASC'">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" viewBox="0 0 16 16">
                                                            <path fill-rule="evenodd"
                                                                  d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z" />
                                                        </svg>
                                                    </template>
                                                    <template v-else>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" viewBox="0 0 16 16">
                                                            <path fill-rule="evenodd"
                                                                  d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                                                        </svg>
                                                    </template>
                                                </button>
                                            </div>
                                        </th>

                                        <!-- Responsável (dsLoginResponsavel - 5/6) -->
                                        <th class="text-center">
                                            <div class="th-wrapper">
                                                <span class="th-title">Responsável</span>
                                                <button @click="ordenarPor('dsLoginResponsavel')"
                                                        class="btn btn-sort"
                                                        :class="{
                        'text-primary': orderField === 'dsLoginResponsavel',
                        'text-gray-300': orderField !== 'dsLoginResponsavel'
                    }">
                                                    <template v-if="orderField === 'dsLoginResponsavel' && orderDirection === 'ASC'">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" viewBox="0 0 16 16">
                                                            <path fill-rule="evenodd"
                                                                  d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z" />
                                                        </svg>
                                                    </template>
                                                    <template v-else>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" viewBox="0 0 16 16">
                                                            <path fill-rule="evenodd"
                                                                  d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                                                        </svg>
                                                    </template>
                                                </button>
                                            </div>
                                        </th>

                                        <!-- Prazo (dtLimite - 7/8) -->
                                        <th class="text-center">
                                            <div class="th-wrapper">
                                                <span class="th-title">Prazo</span>
                                                <button @click="ordenarPor('dtLimite')"
                                                        class="btn btn-sort"
                                                        :class="{
                        'text-primary': orderField === 'dtLimite',
                        'text-gray-300': orderField !== 'dtLimite'
                    }">
                                                    <template v-if="orderField === 'dtLimite' && orderDirection === 'ASC'">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" viewBox="0 0 16 16">
                                                            <path fill-rule="evenodd"
                                                                  d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z" />
                                                        </svg>
                                                    </template>
                                                    <template v-else>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" viewBox="0 0 16 16">
                                                            <path fill-rule="evenodd"
                                                                  d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                                                        </svg>
                                                    </template>
                                                </button>
                                            </div>
                                        </th>

                                        <!-- Status Atual (idTipoStatusHistorico - 9/10) -->
                                        <th class="text-center">
                                            <div class="th-wrapper">
                                                <span class="th-title">Status Atual</span>
                                                <button @click="ordenarPor('idTipoStatusHistorico')"
                                                        class="btn btn-sort"
                                                        :class="{
                        'text-primary': orderField === 'idTipoStatusHistorico',
                        'text-gray-300': orderField !== 'idTipoStatusHistorico'
                    }">
                                                    <template v-if="orderField === 'idTipoStatusHistorico' && orderDirection === 'ASC'">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" viewBox="0 0 16 16">
                                                            <path fill-rule="evenodd"
                                                                  d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z" />
                                                        </svg>
                                                    </template>
                                                    <template v-else>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" viewBox="0 0 16 16">
                                                            <path fill-rule="evenodd"
                                                                  d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                                                        </svg>
                                                    </template>
                                                </button>
                                            </div>
                                        </th>

                                        <!-- Ações (sem ordenação) -->
                                        <th class="text-center">
                                            Ações
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in lstModelosGerais" :key="item.idProcesso">
                                        <td data-label="Número do Processo" class="text-center">{{ item.cdProcesso }}</td>
                                        <td data-label="Nome do Processo">{{ item.dsNomeProcesso }}</td>
                                        <td data-label="Responsável" class="text-center">
                                            <div v-if="item.nmUsuario"
                                                 class="avatar-wrapper"
                                                 data-bs-toggle="popover"
                                                 data-bs-placement="top"
                                                 :data-bs-content="getDataBs(item)">
                                                <div class="modern-avatar"
                                                     :style="item.urlImgFoto ? '' : 'background:#' + intToRGB(hashCode(item.nmUsuario))">
                                                    <img v-if="item.urlImgFoto" :src="item.urlImgFoto" alt="" />
                                                    <span v-else class="avatar-initials">{{ item.nmUsuario.slice(0,2) }}</span>
                                                </div>
                                            </div>
                                            <span v-else>Não definido</span>
                                        </td>

                                        <td data-label="Prazo" class="text-center">{{ formatarData(item.dtLimite) }}</td>
                                        <td data-label="Status Atual" class="text-center">
                                            <span :class="['status-badge', getStatusBadgeClass(item)]">
                                                {{ item.nmStatusAtual || 'Não informado' }}
                                            </span>
                                        </td>
                                        <td data-label="Ações" class="text-center action-cell">
                                            <div class="action-buttons">
                                                <button @click="abrirDetalhes(item)"
                                                        class="action-btn action-btn-view"
                                                        title="Ver Detalhes">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                        <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                                                    </svg>
                                                    <span class="action-text">Detalhes</span>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-if="lstModelosGerais.length === 0">
                                        <td colspan="6" class="empty-state">
                                            <div class="empty-content">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" fill="currentColor" viewBox="0 0 16 16" class="empty-icon">
                                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                                    <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                                                </svg>
                                                <h3 class="empty-title">Nenhum processo encontrado</h3>
                                                <p class="empty-description">
                                                    Não há processos gerais registrados para este modelo.
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="custom-table-footer bg-white text-gray-900 dark:bg-gray-800 dark:text-gray-100 flex justify-between items-center">
                                <div class="pagination-controls flex items-center">
                                    <span @click="previousPage"
                                          :class="['page-box', { 'disabled': currentPage === 0 }]">
                                        <span class="navigation-symbol">«</span>
                                    </span>

                                    <span v-for="page in pagesToShow"
                                          :key="page"
                                          @click="goToPage(page)"
                                          :class="['page-box', page === currentPage ? 'btn btn-primary-soft' : '']">
                                        {{ page + 1 }}
                                    </span>

                                    <span @click="nextPage"
                                          :class="['page-box', { 'disabled': !temProximaPagina }]">
                                        <span class="navigation-symbol">»</span>
                                    </span>
                                </div>

                                <span class="text-sm font-semibold text-gray-600 dark:text-gray-300">
                                    Registros encontrados: {{ qtdRegistros }}
                                </span>
                            </div>
                        </div> <!-- /bloco tabela -->
                    </div>
                </div><!-- tyn-section -->
            </div><!-- tyn-main -->
        </div><!-- tyn-content -->
        <!-- MODAIS -->
        <ModalProcessoArtefatoGeral v-if="processoSelecionadoDetalhe"
                                    :key="processoSelecionadoDetalhe.idProcesso"
                                    :showModal="showModalProcessoArtefato"
                                    :item="processoSelecionadoDetalhe"
                                    @fechar="fecharModalDetalhe"
                                    @atualizar="onAtualizarDetalhe" />
        <Modais></Modais>
    </div>
</template>



<script>
    import Header from '@/components/Header'
    import Modais from '@/components/Modais'
    import axios from 'axios'
    import CardArtefatoGeral from '@/components/CardArtefatoGeral.vue'
    import ModalProcessoArtefatoGeral from '@/components/ModalProcessoArtefatoGeral.vue';
    import { urlApi, avisoToast, avisoErro } from '@/config/global'

    export default {
        name: 'ArtefatosGeraisStatus',
        components: { Header, Modais, CardArtefatoGeral, ModalProcessoArtefatoGeral },
        data: function () {
            return {
                lstModelosGerais: [],
                lstModelos: [],
                modeloSelecionado: null,
                currentPage: 0,
                pageSize: 7,
                qtdRegistros: 0,
                debounceTimeout: null,
                scrollAnimando: false,
                podeScrollEsquerda: false,
                podeScrollDireita: false,
                debounceAtualizarScrollSetas: null,
                lstUsuarios: [],
                mostrarFiltros: false,
                filtro: {
                    dtInicio: null,
                    dtFim: null,
                    dsLoginResponsavel: null,
                    tpStatusPrazo: null
                },
                opcoesStatusPrazo: [
                    { value: null, text: 'Todos' },
                    { value: 1, text: 'Atrasado' },
                    { value: 2, text: 'Em dia' },
                    { value: 3, text: 'Perto de vencer' },
                    { value: 4, text: 'Finalizados' }
                ],
                orderField: 'dtLimite',
                orderDirection: 'ASC',
                orderBy: 7,
                showModalProcessoArtefato: false,
                processoSelecionadoDetalhe: null,
            }
        },

        watch: {
            lstModelos() {
                this.$nextTick(() => {
                    if (this.debounceAtualizarScrollSetas) {
                        this.debounceAtualizarScrollSetas();
                    } else {
                        this.atualizarScrollSetas();
                    }
                });
            }
        },

        methods: {
            load() {
                this.getModelosArtefatos();
            },

            selecionarModelo(modelo) {
                this.modeloSelecionado = modelo;
                this.currentPage = 0;
                this.getModelosArtefatosGerais();
            },

            getModelosArtefatosGerais() {
                let $this = this;
                if (!$this.modeloSelecionado || !$this.modeloSelecionado.idProcessoModeloArtefato) {
                    $this.lstModelosGerais = [];
                    $this.qtdRegistros = 0;
                    return;
                }

                const skip = $this.currentPage * $this.pageSize;
                const take = $this.pageSize;

                const params = {
                    skip: skip,
                    take: take,
                    idProcessoModeloArtefato: $this.modeloSelecionado.idProcessoModeloArtefato
                };

                if ($this.filtro.dtInicio) {
                    params.dtInicio = $this.filtro.dtInicio;
                }

                if ($this.filtro.dtFim) {
                    params.dtFim = $this.filtro.dtFim;
                }

                if ($this.filtro.dsLoginResponsavel) {
                    params.dsLoginResponsavel = $this.filtro.dsLoginResponsavel;
                }

                if ($this.filtro.tpStatusPrazo != null && $this.filtro.tpStatusPrazo !== '') {
                    params.tpStatusPrazo = $this.filtro.tpStatusPrazo;
                }

                if ($this.orderBy != null) {
                    params.orderBy = $this.orderBy;
                }

                axios.get(`${urlApi}/ProcessoArtefato/GetModelosProcessosGerais`, { params })
                    .then(res => {
                        if (res.data.success) {
                            const result = res.data.data;
                            $this.lstModelosGerais = result.rows;
                            $this.qtdRegistros = result.qtdRecords;
                            $this.montaPopover();
                        } else {
                            console.warn("Resposta sem sucesso");
                        }
                    })
                    .catch(err => {
                        console.error("Erro ao fazer requisição:", err);
                        avisoToast("Erro ao carregar processos gerais!", "warning");
                    });
            },

            getModelosArtefatos() {
                let $this = this;
                axios.get(`${urlApi}/ProcessoModeloArtefato/Get`)
                    .then(res => {
                        if (res.data.success) {
                            const result = res.data.data;
                            $this.lstModelos = result;
                        } else {
                            console.warn("Resposta sem sucesso");
                        }
                    })
                    .catch(err => {
                        console.error("Erro ao fazer requisição:", err);
                        avisoToast("Erro ao carregar workflows!", "warning");
                    });
            },

            async getUsuarios() {
                let $this = this;
                try {
                    const { data } = await axios.get(`${urlApi}/ProcessoPermissao/GetUsuariosContrato/`, { showLoading: false });
                    if (data.success) {
                        const rows = data.data || [];
                        if (rows.length > 0) {
                            $this.lstUsuarios = (data.data || []).map(u => ({
                                ...u,
                                isOwner: u.dsLogin === $this.dsLoginProprietario
                            }));
                        } else {
                            await this.getUsuarioInternoAtual();
                        }
                    } else {
                        $this.lstUsuarios = [];
                    }
                } catch (err) {
                    $this.lstUsuarios = [];
                    avisoErro(err.response?.data || err.message || 'Erro ao carregar usuários do contrato.');
                }
            },

            async getUsuarioInternoAtual() {
                let $this = this;
                try {
                    const res = await axios.get(`${urlApi}/ProcessoPermissao/GetUsuariosInternosAtuais/`, { showLoading: false });

                    if (res.data?.success && Array.isArray(res.data.data)) {

                        const lista = res.data.data.map(item => ({
                            ...item,
                            isOwner: item.dsLogin === $this.dsLoginProprietario
                        }));

                        $this.lstUsuarios = lista;

                    } else {
                        avisoErro(res.data?.msg || "Não foi possível carregar o(s) usuário(s) interno(s).");
                    }
                } catch (err) {
                    avisoErro(err?.response?.data || "Não foi possível carregar o usuário interno.");
                }
            },

            toggleFiltros() {
                this.mostrarFiltros = !this.mostrarFiltros;

                if (this.mostrarFiltros && (!this.lstUsuarios || this.lstUsuarios.length === 0)) {
                    this.getUsuarios();
                }
            },

            aplicarFiltros() {
                this.currentPage = 0;
                this.getModelosArtefatosGerais();
            },

            limparFiltros() {
                this.filtro = {
                    dtInicio: null,
                    dtFim: null,
                    dsLoginResponsavel: null,
                    tpStatusPrazo: null
                };
                this.currentPage = 0;
                this.getModelosArtefatosGerais();
            },


            getStatusBadgeClass(item) {
                const status = (item.nmStatusAtual || '').toString().trim().toLowerCase();
                const flWorkflow = item.flWorkflow;
                const isWorkflowFalse =
                    flWorkflow === false ||
                    flWorkflow === 0 ||
                    flWorkflow === 'false' ||
                    flWorkflow === '0';

                if (status === 'finalizado') {
                    return 'status-badge--success';
                }

                if (isWorkflowFalse && status === 'enviado') {
                    return 'status-badge--success';
                }

                const temPrazo = !!item.dtLimite;

                if (!temPrazo) {
                    return 'status-badge--primary';
                }

                const prazo = new Date(item.dtLimite);
                const hoje = new Date();

                if (!isNaN(prazo.getTime())) {
                    prazo.setHours(0, 0, 0, 0);
                    hoje.setHours(0, 0, 0, 0);

                    if (prazo < hoje) {
                        return 'status-badge--danger';
                    }

                    return 'status-badge--warning';
                }

                return 'status-badge--primary';
            },

            previousPage() {
                if (this.currentPage > 0) {
                    this.currentPage--;
                    this.getModelosArtefatosGerais();
                }
            },

            nextPage() {
                if (this.temProximaPagina) {
                    this.currentPage++;
                    this.getModelosArtefatosGerais();
                }
            },

            goToPage(pageIndex) {
                if (pageIndex !== this.currentPage) {
                    this.currentPage = pageIndex;
                    this.getModelosArtefatosGerais();
                }
            },

            formatarData(dataISO) {
                if (!dataISO) return 'Sem prazo';
                const data = new Date(dataISO);
                return data.toLocaleDateString('pt-BR');
            },

            hashCode(str) {
                var hash = 0;
                for (var i = 0; i < str.length; i++) {
                    hash = str.charCodeAt(i) + ((hash << 5) - hash);
                }
                return hash;
            },
            intToRGB(i) {
                var c = (i & 0x00FFFFFF)
                    .toString(16)
                    .toUpperCase();
                return "00000".substring(0, 6 - c.length) + c;
            },
            getDataBs(item) {
                return ` <span class="mb-0">${item.nmUsuario}</span> `;
            },

            montaPopover() {
                const popovers = document.querySelectorAll('.popover');
                popovers.forEach(popover => popover.remove());

                this.$nextTick(() => {
                    const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');

                    if (popoverTriggerList.length > 0) {
                        [].slice.call(popoverTriggerList).map(function (popoverTriggerEl) {
                            return new window.bootstrap.Popover(popoverTriggerEl, {
                                trigger: 'hover',
                                boundary: 'window',
                                html: true,
                                customClass: 'custom-popover'
                            });
                        });
                    }
                });
            },

            scrollEsquerda() {
                const el = this.$refs.scrollContainer;
                if (!el) return;
                this.animateScroll(el, -220);
            },

            scrollDireita() {
                const el = this.$refs.scrollContainer;
                if (!el) return;

                const scrollRight = el.scrollWidth - el.scrollLeft - el.clientWidth;
                const minimoScroll = 20;
                const scrollValue = scrollRight < 220 ? scrollRight - 20 : 220;

                this.animateScroll(el, Math.max(scrollValue, minimoScroll));
            },

            animateScroll(element, distance) {
                if (this.scrollAnimando) return;
                this.scrollAnimando = true;

                const maxScroll = element.scrollWidth - element.clientWidth;
                const initial = element.scrollLeft;
                const target = Math.max(0, Math.min(initial + distance, maxScroll));
                const duration = 400;
                const startTime = performance.now();

                const step = (now) => {
                    const elapsed = now - startTime;
                    const progress = Math.min(elapsed / duration, 1);
                    const ease = 0.5 - Math.cos(progress * Math.PI) / 2;
                    const scrollValue = initial + (target - initial) * ease;
                    element.scrollLeft = scrollValue;

                    if (progress < 1) {
                        requestAnimationFrame(step);
                    } else {
                        element.scrollLeft = target;
                        this.scrollAnimando = false;
                        this.$nextTick(() => {
                            setTimeout(() => this.atualizarScrollSetas(), 60);
                        });
                    }
                };

                requestAnimationFrame(step);
            },

            atualizarScrollSetas() {
                if (this.scrollAnimando) return;
                const el = this.$refs.scrollContainer;
                if (!el) return;

                const scrollLeft = el.scrollLeft;
                const clientWidth = el.clientWidth;
                const scrollWidth = el.scrollWidth;
                const margemErro = 2;

                const posInicio = scrollLeft <= margemErro;
                const posFim = Math.abs(scrollLeft + clientWidth - scrollWidth) <= margemErro;

                this.podeScrollEsquerda = !posInicio;
                this.podeScrollDireita = !posFim;
            },

            abrirDetalhes(item) {
                if (!item || !item.idProcesso) return;

                this.showModalProcessoArtefato = false;
                this.processoSelecionadoDetalhe = { ...item };
                this.$nextTick(() => {
                    this.showModalProcessoArtefato = true;
                });
            },

            fecharModalDetalhe() {
                this.showModalProcessoArtefato = false;
                this.$nextTick(() => {
                    this.processoSelecionadoDetalhe = null;
                });
            },

            onAtualizarDetalhe() {
                this.getModelosArtefatosGerais();
            },

            ordenarPor(campo) {
                if (this.orderField === campo) {
                    this.orderDirection = this.orderDirection === 'ASC' ? 'DESC' : 'ASC';
                } else {
                    this.orderField = campo;
                    this.orderDirection = 'ASC';
                }
                this.orderBy = this.mapOrderBy(this.orderField, this.orderDirection);
                this.currentPage = 0;
                this.getModelosArtefatosGerais();
            },

            mapOrderBy(campo, direction) {
                const map = {
                    cdProcesso: { ASC: 1, DESC: 2 },
                    dsNomeProcesso: { ASC: 3, DESC: 4 },
                    dsLoginResponsavel: { ASC: 5, DESC: 6 },
                    dtLimite: { ASC: 7, DESC: 8 },
                    idTipoStatusHistorico: { ASC: 9, DESC: 10 }
                };

                const cfg = map[campo];
                if (!cfg) return 7;

                return cfg[direction] || 7;
            },

        },

        mounted: function () {
            this.load();

            this.debounceAtualizarScrollSetas = () => {
                if (this.debounceTimeout) clearTimeout(this.debounceTimeout);
                this.debounceTimeout = setTimeout(() => this.atualizarScrollSetas(), 120);
            };

            window.addEventListener('resize', this.debounceAtualizarScrollSetas);

            this.$nextTick(() => {
                const el = this.$refs.scrollContainer;
                if (el) {
                    el.addEventListener('scroll', this.atualizarScrollSetas);
                    this.atualizarScrollSetas();
                }
            });
        },


        beforeDestroy() {
            window.removeEventListener('resize', this.debounceAtualizarScrollSetas);
            const el = this.$refs.scrollContainer;
            if (el) {
                el.removeEventListener('scroll', this.atualizarScrollSetas);
            }
            if (this.debounceTimeout) clearTimeout(this.debounceTimeout);
        },

        computed: {
            totalPages() {
                return Math.ceil(this.qtdRegistros / this.pageSize || 1);
            },
            temProximaPagina() {
                return (this.currentPage + 1) < this.totalPages;
            },
            pagesToShow() {
                const maxPages = 5;
                const pages = [];

                let start = Math.max(this.currentPage - 2, 0);
                let end = Math.min(start + maxPages, this.totalPages);

                if (end - start < maxPages) {
                    start = Math.max(end - maxPages, 0);
                }

                for (let i = start; i < end; i++) {
                    pages.push(i);
                }

                return pages;
            },
            user() {
                return this.$store.state.user;
            },
            isAdmContrato() {
                return this.$store.state.isAdmContrato
            },
            isContratoZero() {
                return this.user.usuario.idContrato === 0;
            },
            isAdmOuInterno() {
                return this.isAdmContrato == 'Sim' || this.isContratoZero;
            },
            temFiltrosAtivos() {
                return !!(this.filtro.dtInicio || this.filtro.dtFim || this.filtro.dsLoginResponsavel || (this.filtro.tpStatusPrazo != null && this.filtro.tpStatusPrazo !== ''));
            }
        }

    };
</script>

<style lang="css" scoped>
    .tyn-section {
        overflow-x: hidden;
    }

    .artefatos-bar {
        width: 100vw;
        margin-left: calc(50% - 50vw);
        margin-right: calc(50% - 50vw);
        padding: 1rem 0;
        border-bottom: 1px solid rgba(226, 232, 240, 0.8);
        box-shadow: 0 4px 20px rgba(15, 23, 42, 0.08);
        position: relative;
        z-index: 5;
    }

    [data-bs-theme='dark'] .artefatos-bar {
        background: rgba(15, 23, 42, 0.95) !important;
        border-bottom: 1px solid rgba(51, 65, 85, 0.7);
        box-shadow: 0 6px 24px rgba(0, 0, 0, 0.35);
    }

    .artefato-scroll-wrapper {
        position: relative;
        overflow-x: auto;
        overflow-y: visible;
        padding: 0.25rem 0.5rem;
        margin: 0 2.75rem;
        scrollbar-width: none;
    }

        .artefato-scroll-wrapper::-webkit-scrollbar {
            display: none;
        }

    .artefato-container {
        display: flex;
        flex-wrap: nowrap;
        gap: 0.75rem;
        min-width: max-content;
    }

        .artefato-container > * {
            flex: 0 0 auto;
        }

    .scroll-btn {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        z-index: 10;
        width: 48px;
        height: 48px;
        border-radius: 50%;
        border: 1px solid #e2e8f0;
        background: white;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #2563eb;
        box-shadow: 0 6px 20px rgba(37, 99, 235, 0.15);
        transition: all 0.25s ease;
        cursor: pointer;
    }

        .scroll-btn.left {
            left: 0.75rem;
        }

        .scroll-btn.right {
            right: 0.75rem;
        }

        .scroll-btn:hover {
            background: #2563eb;
            color: white;
            border-color: #2563eb;
            transform: translateY(-50%) scale(1.08);
            box-shadow: 0 8px 24px rgba(37, 99, 235, 0.3);
        }

    [data-bs-theme='dark'] .scroll-btn {
        background: #1e293b;
        border-color: #334155;
        color: #60a5fa;
        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.45);
    }

        [data-bs-theme='dark'] .scroll-btn:hover {
            background: #3b82f6;
            color: white;
            border-color: #3b82f6;
        }

    @media (max-width: 991.98px) {
        .artefatos-bar {
            padding: 0.75rem 0;
        }

        .artefato-scroll-wrapper {
            margin: 0 2rem;
        }

        .scroll-btn {
            width: 42px;
            height: 42px;
        }
    }

    @media (max-width: 575.98px) {
        .artefatos-bar {
            padding: 0.5rem 0;
        }

        .artefato-scroll-wrapper {
            margin: 0 1.5rem;
            padding: 0.25rem 0.25rem;
        }

        .artefato-container {
            gap: 0.5rem;
        }

        .scroll-btn {
            width: 36px;
            height: 36px;
        }
    }

    .table-container {
        margin-top: 15px;
        width: 100%;
    }

    @media (max-width: 768px) {
        .table-container {
            padding-left: 8px;
            padding-right: 8px;
        }
    }

    .table-wrapper {
        width: 100%;
        padding: 0 10px;
        margin: 0 auto;
        overflow-x: auto;
        min-height: 700px;
    }

    @media (max-width: 768px) {
        .table-wrapper {
            padding: 0 4px;
            min-height: 500px;
        }
    }

    .custom-table-header {
        background: linear-gradient(to bottom, #ffffff 0%, #fafafa 100%);
        border: 1px solid #e5e7eb;
        border-bottom: none;
        border-radius: 12px 12px 0 0;
        padding: 16px 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
        flex-wrap: wrap;
    }

    @media (max-width: 768px) {
        .custom-table-header {
            padding: 12px 16px;
            flex-direction: column;
            align-items: stretch;
        }
    }


        .custom-table-header h3 {
            margin: 0;
            font-size: 1.15rem;
            font-weight: 700;
            color: #0f172a;
        }

        .custom-table-header small {
            color: #94a3b8;
            font-weight: 600;
        }

    .custom-table {
        width: 100%;
        border: 1px solid #e5e7eb;
        border-radius: 0;
        box-shadow: none;
        border-collapse: collapse;
        background: white;
    }

        .custom-table th,
        .custom-table td {
            padding: 16px 20px;
            text-align: left;
            border-bottom: 1px solid #f3f4f6;
            transition: all 0.2s ease;
        }

        /* Larguras das colunas apenas no desktop */
        @media (min-width: 769px) {
            .custom-table th:nth-child(1),
            .custom-table td:nth-child(1) {
                width: 14%;
            }

            .custom-table th:nth-child(2),
            .custom-table td:nth-child(2) {
                width: 33%;
            }

            .custom-table th:nth-child(3),
            .custom-table td:nth-child(3) {
                width: 18%;
            }

            .custom-table th:nth-child(4),
            .custom-table td:nth-child(4) {
                width: 12%;
            }

            .custom-table th:nth-child(5),
            .custom-table td:nth-child(5) {
                width: 13%;
            }

            .custom-table th:nth-child(6),
            .custom-table td:nth-child(6) {
                width: 10%;
            }
        }

        .custom-table td {
            font-size: 15px;
            color: #374151;
        }

            .custom-table td.action-cell {
                overflow: visible;
            }

        .custom-table th {
            font-weight: 700;
            font-size: 14px;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            background-color: #f8fafc;
            color: #94a3b8;
        }

        .custom-table tbody tr:hover {
            background-color: #f9fafb;
            transform: scale(1.002);
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
        }

    .custom-table-footer {
        border: 1px solid #e5e7eb;
        border-top: none;
        border-radius: 0 0 12px 12px;
        padding: 16px 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-weight: 600;
        font-size: 14px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
        background: linear-gradient(to bottom, #fafafa 0%, #ffffff 100%);
    }

    @media (max-width: 768px) {
        .custom-table-footer {
            padding: 16px;
            flex-direction: column;
            align-items: center;
            font-size: 13px;
            gap: 16px;
        }

        .custom-table-footer > span {
            order: 2;
            text-align: center;
            width: 100%;
            padding: 8px 0;
            background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);
            border-radius: 8px;
            color: #374151;
        }

        .pagination-controls {
            order: 1;
            width: 100%;
            max-width: 400px;
        }
    }

    .pagination-controls {
        display: flex;
        gap: 6px;
        flex-wrap: wrap;
        justify-content: center;
    }

    @media (max-width: 768px) {
        .pagination-controls {
            gap: 8px;
            padding: 8px 0;
        }
    }

    @media (max-width: 480px) {
        .pagination-controls {
            gap: 6px;
            padding: 4px 0;
        }
    }

    .page-box {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 38px;
        height: 38px;
        border: 2px solid #e5e7eb;
        border-radius: 8px;
        line-height: 1;
        font-weight: 600;
        font-size: 14px;
        cursor: pointer;
        transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
        background: white;
    }

        .page-box:hover {
            background-color: #f3f4f6;
            border-color: #2563eb;
            transform: translateY(-2px);
            box-shadow: 0 2px 8px rgba(37, 99, 235, 0.15);
        }

        .page-box.disabled {
            opacity: 0.4;
            pointer-events: none;
        }

        .page-box.btn.btn-primary-soft {
            background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
            color: white;
            border-color: #2563eb;
            box-shadow: 0 2px 8px rgba(37, 99, 235, 0.2);
        }

    @media (max-width: 768px) {
        .page-box {
            width: 40px;
            height: 40px;
            font-size: 14px;
            border-width: 2px;
            font-weight: 700;
            flex-shrink: 0;
        }

        .page-box:hover {
            transform: scale(1.05);
        }

        .navigation-symbol {
            font-size: 20px;
        }
    }

    @media (max-width: 480px) {
        .page-box {
            width: 36px;
            height: 36px;
            font-size: 13px;
            flex-shrink: 0;
        }

        .page-box:hover {
            transform: scale(1.03);
        }

        .navigation-symbol {
            font-size: 18px;
        }
    }

    @media (max-width: 360px) {
        .page-box {
            width: 32px;
            height: 32px;
            font-size: 12px;
        }

        .navigation-symbol {
            font-size: 16px;
        }

        .pagination-controls {
            gap: 4px;
        }
    }

    .empty-state {
        padding: 80px 20px !important;
        background: linear-gradient(to bottom, #fafafa 0%, #ffffff 100%);
        text-align: center;
    }

    .empty-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
        animation: fadeInUp 0.5s ease-out;
    }

    .empty-icon {
        color: #cbd5e1;
        margin-bottom: 8px;
    }

    .empty-title {
        font-size: 24px;
        font-weight: 700;
        color: #1f2937;
        margin: 0;
    }

    .empty-description {
        font-size: 16px;
        color: #6b7280;
        margin: 0;
    }

    @media (max-width: 768px) {
        .custom-table,
        .custom-table thead,
        .custom-table tbody,
        .custom-table th,
        .custom-table td,
        .custom-table tr {
            display: block;
            width: 100%;
        }

            .custom-table thead {
                display: none;
            }

            .custom-table tr {
                margin-bottom: 16px;
                border-radius: 12px;
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
                overflow: hidden;
                border: 1px solid #e5e7eb;
            }

            .custom-table td {
                text-align: left !important;
                padding: 14px 16px;
                position: relative;
                border: none;
                border-bottom: 1px solid #f3f4f6;
            }

                .custom-table td::before {
                    content: attr(data-label);
                    font-weight: 700;
                    display: block;
                    margin-bottom: 6px;
                    color: #4b5563;
                    font-size: 12px;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                }

                .custom-table td:last-child {
                    border-bottom: none;
                    padding: 16px !important;
                    background: #f9fafb;
                }

        /* Remove padding extra da coluna de ações no responsivo */
        .action-cell {
            padding-right: 16px !important;
            white-space: normal !important;
        }

        /* Melhorias nos botões de ação no modo responsivo */
        .action-buttons {
            flex-direction: row;
            gap: 10px;
            justify-content: flex-start;
            flex-wrap: wrap;
        }

        .action-btn {
            flex: 1;
            min-width: 120px;
            justify-content: center;
            padding: 12px 16px;
            font-size: 14px;
            min-height: 44px;
            touch-action: manipulation;
        }

        .action-btn svg {
            width: 18px;
            height: 18px;
        }

        .action-text {
            display: inline;
            font-weight: 600;
        }

        .action-btn:active {
            transform: scale(0.98);
        }

        .action-btn-view {
            flex: 1.2;
        }

        /* Avatares menores no responsivo */
        .modern-avatar {
            width: 36px;
            height: 36px;
        }

        .avatar-small {
            width: 32px;
            height: 32px;
        }

        .avatars-group {
            justify-content: flex-start;
        }

        /* Badges responsivos */
        .status-badge {
            font-size: 13px;
            padding: 6px 10px;
        }
    }

    /* Dark theme para cards responsivos */
    [data-bs-theme="dark"] {
        @media (max-width: 768px) {
            .custom-table tr {
                border-color: #374151;
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
            }

            .custom-table td {
                border-bottom-color: #374151;
            }

            .custom-table td::before {
                color: #9ca3af;
            }

            .custom-table td:last-child {
                background: #1f2937;
            }
        }
    }

    [data-bs-theme='dark'] .custom-table-header,
    [data-bs-theme='dark'] .custom-table-footer {
        background: linear-gradient(to bottom, #1f2937 0%, #111827 100%);
        border-color: #334155;
    }

    [data-bs-theme='dark'] {
        @media (max-width: 768px) {
            .custom-table-footer > span {
                background: linear-gradient(135deg, #374151 0%, #4b5563 100%);
                color: #e5e7eb;
            }
        }
    }

        [data-bs-theme='dark'] .custom-table-header h3,
        [data-bs-theme='dark'] .custom-table-header small {
            color: #f8fafc;
        }

    [data-bs-theme='dark'] .custom-table {
        background: #1f2937;
    }

        [data-bs-theme='dark'] .custom-table td {
            color: #e5e7eb;
            border-bottom: 1px solid #475569;
        }

        [data-bs-theme='dark'] .custom-table th {
            background-color: #1f2937;
            color: #94a3b8;
        }

        [data-bs-theme='dark'] .custom-table tbody tr:hover {
            background-color: #374151;
        }

    [data-bs-theme='dark'] .page-box {
        background-color: #1e293b;
        border: 2px solid #334155;
        color: #cbd5e1;
    }

        [data-bs-theme='dark'] .page-box:hover {
            background-color: #334155;
            border-color: #3b82f6;
        }

        [data-bs-theme='dark'] .page-box.btn.btn-primary-soft {
            background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
            color: white;
            border: 2px solid #3b82f6;
        }

    [data-bs-theme='dark'] .empty-state {
        background: linear-gradient(to bottom, #1f2937 0%, #111827 100%);
    }

    [data-bs-theme='dark'] .empty-title {
        color: #f9fafb;
    }

    [data-bs-theme='dark'] .empty-description {
        color: #9ca3af;
    }

    .status-badge {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 0rem 0.6rem;
        border-radius: 999px;
        font-size: 0.75rem;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.04em;
    }

    .status-badge--primary {
        background-color: #e0edff;
        color: #1d4ed8;
    }

    .status-badge--success {
        background-color: #dcfce7;
        color: #16a34a;
    }

    .status-badge--warning {
        background-color: #fef3c7;
        color: #d97706;
    }

    .status-badge--danger {
        background-color: #fee2e2;
        color: #b91c1c;
    }

    [data-bs-theme='dark'] .status-badge--primary {
        background-color: rgba(37, 99, 235, 0.2);
        color: #bfdbfe;
    }

    [data-bs-theme='dark'] .status-badge--success {
        background-color: rgba(22, 163, 74, 0.25);
        color: #bbf7d0;
    }

    [data-bs-theme='dark'] .status-badge--warning {
        background-color: rgba(217, 119, 6, 0.25);
        color: #fed7aa;
    }

    [data-bs-theme='dark'] .status-badge--danger {
        background-color: rgba(185, 28, 28, 0.3);
        color: #fecaca;
    }

    /* Avatares Modernos */
    .avatar-wrapper {
        display: inline-flex;
        justify-content: center;
        align-items: center;
    }

    .modern-avatar {
        width: 44px;
        height: 44px;
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        border: 3px solid white;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        cursor: pointer;
    }

        .modern-avatar:hover {
            transform: scale(1.1) translateY(-2px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
        }

        .modern-avatar img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }

    .avatar-initials {
        color: white;
        font-weight: 700;
        font-size: 16px;
        text-transform: uppercase;
        letter-spacing: 0.5px;
    }

    .avatar-small {
        width: 38px;
        height: 38px;
        border-radius: 10px;
        border: 2px solid white;
    }

        .avatar-small .avatar-initials {
            font-size: 14px;
        }

    .avatars-group {
        display: inline-flex;
        gap: -8px;
        justify-content: center;
        align-items: center;
    }

        .avatars-group .modern-avatar {
            margin-left: -8px;
        }

            .avatars-group .modern-avatar:first-child {
                margin-left: 0;
            }

            .avatars-group .modern-avatar:hover {
                z-index: 10;
            }

    [data-bs-theme="dark"] .modern-avatar {
        border-color: #1f2937;
    }

    /* Botão de Filtro no Header */
    .filter-toggle-btn {
        position: relative;
        width: 40px;
        height: 40px;
        border-radius: 10px;
        border: 2px solid #e5e7eb;
        background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        color: #64748b;
        flex-shrink: 0;
    }

        .filter-toggle-btn:hover {
            border-color: #2563eb;
            background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
            color: #2563eb;
            transform: scale(1.05);
            box-shadow: 0 4px 12px rgba(37, 99, 235, 0.15);
        }

        .filter-toggle-btn.active {
            background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
            border-color: #2563eb;
            color: white;
            box-shadow: 0 4px 12px rgba(37, 99, 235, 0.25);
        }

            .filter-toggle-btn.active:hover {
                background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
            }

    .filter-badge {
        position: absolute;
        top: 4px;
        right: 4px;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #ef4444;
        border: 2px solid white;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    .slide-filters-enter-active,
    .slide-filters-leave-active {
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        max-height: 500px;
        opacity: 1;
    }

    .slide-filters-enter-from,
    .slide-filters-leave-to {
        max-height: 0;
        opacity: 0;
        overflow: hidden;
    }

    .filters-panel {
        background: linear-gradient(135deg, #ffffff 0%, #fafafa 100%);
        border: 2px solid #e5e7eb;
        border-top: none;
        border-radius: 0 0 12px 12px;
        padding: 24px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
        margin-bottom: 0;
    }

    .filters-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
        gap: 20px;
        margin-bottom: 20px;
    }

    .filter-item {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .filter-label {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 13px;
        font-weight: 600;
        color: #475569;
        text-transform: uppercase;
        letter-spacing: 0.5px;
    }

    .filter-icon {
        color: #64748b;
        flex-shrink: 0;
    }

    .filter-input {
        width: 100%;
        padding: 12px 16px;
        border: 2px solid #e5e7eb;
        border-radius: 10px;
        font-size: 14px;
        color: #1f2937;
        background: #ffffff;
        transition: all 0.2s ease;
        font-family: inherit;
    }

        .filter-input:focus {
            outline: none;
            border-color: #2563eb;
            box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
            background: #ffffff;
        }

        .filter-input::placeholder {
            color: #94a3b8;
        }

    .select-wrapper {
        position: relative;
    }

        .select-wrapper::after {
            content: '';
            position: absolute;
            right: 16px;
            top: 50%;
            transform: translateY(-50%);
            width: 14px;
            height: 9px;
            background-image: url("data:image/svg+xml,%3Csvg width='14' height='9' viewBox='0 0 14 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L7 7.5L13 1.5' stroke='%23838B99' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
            background-repeat: no-repeat;
            background-size: contain;
            pointer-events: none;
            transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            z-index: 1;
        }

        .select-wrapper:focus-within::after {
            transform: translateY(-50%) rotate(180deg);
            background-image: url("data:image/svg+xml,%3Csvg width='14' height='9' viewBox='0 0 14 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L7 7.5L13 1.5' stroke='%232563eb' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
        }

    .filter-select {
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        padding-right: 44px;
        cursor: pointer;
        width: 100%;
    }

    .filters-actions {
        display: flex;
        justify-content: flex-end;
        gap: 12px;
        padding-top: 20px;
        border-top: 1px solid #e5e7eb;
    }

    .filter-btn {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        padding: 12px 24px;
        border-radius: 10px;
        font-size: 14px;
        font-weight: 600;
        border: none;
        cursor: pointer;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    }

        .filter-btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }

        .filter-btn:active {
            transform: translateY(0);
        }

    .filter-btn-primary {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        color: white;
    }

        .filter-btn-primary:hover {
            background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
            box-shadow: 0 6px 16px rgba(37, 99, 235, 0.35);
        }

    .filter-btn-secondary {
        background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
        color: #475569;
        border: 2px solid #e5e7eb;
    }

        .filter-btn-secondary:hover {
            background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%);
            border-color: #cbd5e1;
        }

    [data-bs-theme="dark"] .filter-toggle-btn {
        background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
        border-color: #334155;
        color: #94a3b8;
    }

        [data-bs-theme="dark"] .filter-toggle-btn:hover {
            border-color: #3b82f6;
            background: linear-gradient(135deg, rgba(59, 130, 246, 0.2) 0%, rgba(45, 212, 191, 0.2) 100%);
            color: #60a5fa;
        }

        [data-bs-theme="dark"] .filter-toggle-btn.active {
            background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
            border-color: #3b82f6;
            color: white;
        }

            [data-bs-theme="dark"] .filter-toggle-btn.active:hover {
                background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);
            }

    [data-bs-theme="dark"] .filters-panel {
        background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
        border-color: #334155;
    }

    [data-bs-theme="dark"] .filter-label {
        color: #cbd5e1;
    }

    [data-bs-theme="dark"] .filter-icon {
        color: #94a3b8;
    }

    [data-bs-theme="dark"] .filter-input {
        background: rgba(15, 23, 42, 0.8);
        border-color: #334155;
        color: #e5e7eb;
    }

        [data-bs-theme="dark"] .filter-input:focus {
            border-color: #3b82f6;
            background: rgba(15, 23, 42, 0.95);
            box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
        }

    [data-bs-theme="dark"] .select-wrapper::after {
        background-image: url("data:image/svg+xml,%3Csvg width='14' height='9' viewBox='0 0 14 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L7 7.5L13 1.5' stroke='%2394a3b8' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    }

    [data-bs-theme="dark"] .select-wrapper:focus-within::after {
        background-image: url("data:image/svg+xml,%3Csvg width='14' height='9' viewBox='0 0 14 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L7 7.5L13 1.5' stroke='%2360a5fa' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    }

    [data-bs-theme="dark"] .filters-actions {
        border-top-color: #334155;
    }

    [data-bs-theme="dark"] .filter-btn-secondary {
        background: linear-gradient(135deg, #334155 0%, #475569 100%);
        color: #cbd5e1;
        border-color: #475569;
    }

        [data-bs-theme="dark"] .filter-btn-secondary:hover {
            background: linear-gradient(135deg, #475569 0%, #64748b 100%);
            border-color: #64748b;
        }

    @media (max-width: 768px) {
        .filters-grid {
            grid-template-columns: 1fr;
            gap: 16px;
        }

        .filters-panel {
            padding: 20px 16px;
        }

        .filters-actions {
            flex-direction: column-reverse;
        }

        .filter-btn {
            width: 100%;
            justify-content: center;
        }
    }

    .th-wrapper {
        position: relative;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        min-height: 20px;
    }

    .th-title {
        text-align: center;
        font-weight: 700;
        letter-spacing: 0.3px;
        white-space: nowrap;
    }

    .th-wrapper.left {
        align-items: center;
        justify-content: flex-start;
        padding: 0;
        gap: 4px;
    }

        .th-wrapper.left .th-title {
            text-align: left;
        }

    .btn-sort {
        position: relative;
        padding: 4px;
        width: 20px;
        height: 20px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        transition: all 0.2s ease;
        flex-shrink: 0;
        margin-left: 4px;
    }

        .btn-sort:hover {
            transform: scale(1.1);
        }

    .btn-sort-inline {
        position: relative;
        padding: 4px;
        width: 20px;
        height: 20px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        transition: all 0.2s ease;
        flex-shrink: 0;
        margin-left: 8px;
    }

        .btn-sort-inline:hover {
            transform: scale(1.1);
        }

    /* Botões de Ação na Tabela */
    .action-buttons {
        display: flex;
        gap: 8px;
        justify-content: center;
        align-items: center;
    }

    .action-btn {
        display: inline-flex;
        align-items: center;
        gap: 2px;
        padding: 4px 12px;
        border-radius: 8px;
        font-weight: 600;
        font-size: 13px;
        cursor: pointer;
        transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
        border: 2px solid transparent;
        white-space: nowrap;
        position: relative;
        overflow: hidden;
    }

        .action-btn svg {
            flex-shrink: 0;
            display: block;
            width: 16px;
            height: 16px;
        }

        .action-btn::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            width: 220%;
            height: 220%;
            border-radius: 50%;
            background: rgba(255,255,255,0.30);
            transform: translate(-50%, -50%) scale(0);
            transition: transform .6s ease;
            pointer-events: none;
        }

        .action-btn:hover::before {
            transform: translate(-50%, -50%) scale(1);
        }

    .action-btn-view {
        background: linear-gradient(135deg, #10b981 0%, #059669 100%);
        color: white;
        border-color: transparent;
        box-shadow: 0 2px 8px rgba(16, 185, 129, 0.2);
    }

        .action-btn-view:hover {
            background: linear-gradient(135deg, #059669 0%, #047857 100%);
            transform: translateY(-2px);
            box-shadow: 0 6px 16px rgba(16, 185, 129, 0.4);
        }

    .action-btn:active {
        transform: translateY(0);
    }
</style>

